/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type { AtlassianAnalyticsApp as LazyAtlassianAnalyticsAppType } from '@jira/spa-apps__servicedesk-atlassian-analytics/src/AtlassianAnalyticsApp.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyAtlassianAnalytics: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof LazyAtlassianAnalyticsAppType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-atlassian-analytics", jiraSpaEntry: "async-servicedesk-atlassian-analytics" */ '@jira/spa-apps__servicedesk-atlassian-analytics/src/ServicedeskAtlassianAnalytics.tsx'
		),
	),
);

export const AtlassianAnalytics = (): React.JSX.Element => (
	<LazyPage
		Page={LazyAtlassianAnalytics}
		pageId="spa-apps/servicedesk/atlassian-analytics"
		shouldShowSpinner
	/>
);
